<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <el-form-item label="类型" prop="video_type">
                <el-radio-group v-model="form.video_type" @change="handleTypeChange">
                    <el-radio :label="1">视频</el-radio>
                    <el-radio :label="2">音频</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="标题" clearable/>
            </el-form-item>

            <el-form-item label="封面" prop="image_id">
                <el-row>
                    <el-button type="primary" @click="openUpload('image', 'thumb')">选择图片</el-button>
                    <div v-if="form.image_id !== ''" class="img">
                        <el-image
                                style="height: 100px"
                                :src="form.file_path"
                                fit="contain"></el-image>
<!--                        <img :src="form.file_path" height="100" />-->
                    </div>
                </el-row>
            </el-form-item>

            <el-form-item label="视频" v-if="form.video_type === 1">
                <el-row>
                    <div class="draggable-list">
                        <div class="item img-select" v-if="form.file_id===0" @click="openUpload('video', 'video')"><i class="el-icon-plus"></i></div>
                        <div v-if="form.file_id>0">
                            <!--                            <video width="150" height="150" :src="form.video.file_path" :autoplay="false" controls>-->
                            <!--                                您的浏览器不支持 video 标签-->
                            <!--                            </video>-->
                            <video ref="video" v-if="form.file_id > 0" width="50%" height="50%" controls>
                                <source :src="form.file.file_path" type="video/mp4">
                                <object :data="form.file.file_path" width="100%" height="100%">
                                    <embed :src="form.file.file_path" width="100%" height="100%">
                                </object>
                            </video>
                            <div>
                                <el-button icon="el-icon-picture-outline" @click="delFile">删除</el-button>
                            </div>
                        </div>
                    </div>
                </el-row>
            </el-form-item>

            <el-form-item label="音频" v-if="form.video_type === 2">
                <el-row>
                    <div class="draggable-list">
                        <div class="item img-select" v-if="form.file_id===0" @click="openUpload('audio', 'audio')"><i class="el-icon-plus"></i></div>
                        <div v-if="form.file_id>0">
<!--                            <audio :src="form.audio.file_path" controls="controls">-->
<!--                                您的浏览器不支持音频元素。-->
<!--                            </audio>-->
                            <audio controls height="100" width="100">
                                <source :src="form.file.file_path" type="audio/mpeg">
                                <source :src="form.file.file_path" type="audio/ogg">
                                <embed height="50" width="100" :src="form.file.file_path">
                            </audio>
                            <div>
                                <el-button icon="el-icon-picture-outline" @click="delFile">删除</el-button>
                            </div>
                        </div>
                    </div>
                </el-row>
            </el-form-item>


<!--            <el-form-item label="虚拟参与数" prop="title">-->
<!--                <el-input v-model.number="form.set_enroll_num" placeholder="虚拟参与数" clearable/>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="内容" prop="content">-->
<!--                <Editor :text="form.content" @get-content="contentChangeFunc" :width="600" ></Editor>-->
<!--            </el-form-item>-->

            <el-form-item label="状态">
                <el-radio-group v-model="form.is_show">
                    <el-radio :label="1">显示</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>

        <!--上传图片组件-->
        <Upload v-if="isupload" :config.sync="file_config" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    </el-dialog>
</template>

<script>
    import { videoEdit, videoDetail, getSetting } from '@/api/education'
    import Upload from '@/components/file/Upload'
    // import Editor from '@/components/tsk/editor'

    export default {
        components: { Upload,
            // Editor
        },
        data() {
            return {
                title: '',
                form: {
                    video_id: 0,
                    title: '',
                    video_type: 1,
                    image_id: '',
                    file_path: '',
                    file_id: 0,
                    file:[],
                    content: '',
                    sort: 1,
                    is_show: 1,
                },
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*链接选择*/
                is_linkset: false,
                // 验证
                formRules: {
                    name: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }]
                },
                /*上传图片*/
                isupload: false,
                file_name: 'thumb',
                file_config: {},
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加音视频'
                } else {
                    this.title = '编辑音视频'
                    this.form.video_id = row.video_id
                    this.getDetail()
                }
                // this.getSet()
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.form = this.$options.data().form
                this.form.content = ''
                this.activity_fields = []
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        videoEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            getDetail(){
                videoDetail({id: this.form.video_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                    this.form.file = result.data.file
                    // if(result.data.is_vote > 0 && result.data.vote){
                    //     this.form.user_max_num = result.data.vote.user_max_num
                    //     this.form.cmpe_max_num = result.data.vote.cmpe_max_num
                    // }
                })
            },
            handleTypeChange(val){
                this.form.activity_type = val
            },
            contentChangeFunc(val){
                this.form.content = val
            },

            // 图片上传
            openUpload(file_type, file_name) {
                this.file_name = file_name;
                if (file_name === 'thumb') { // 封面图
                    this.file_config = {
                        total: 1,
                        file_type: 'image'
                    };
                }
                if(file_name === 'images'){
                    this.file_config = {
                        total: 9,
                        file_type: 'image'
                    };
                }

                if(file_name === 'video'){
                    this.file_config = {
                        total: 1,
                        file_type: 'video'
                    };
                }

                if(file_name === 'audio'){
                    this.file_config = {
                        total: 1,
                        file_type: 'audio'
                    };
                }

                if(file_name === 'file'){
                    this.file_config = {
                        total: 1,
                        file_type: 'file'
                    };
                }
                this.isupload = true;
            },

            /*获取图片*/
            returnImgsFunc(e) {
                if (e === null) {
                    this.isupload = false
                    return
                }
                if (this.file_name === 'thumb') { // 封面图
                    this.form.image_id = e[0].file_id;
                    this.form.file_path = e[0].file_path;
                }
                if (this.file_name === 'images') { // 产品图多张
                    for (let i = 0, e_length = e.length; i < e_length; i++) {
                        if (this.form.images.length >= 9) {
                            this.isupload = false
                            this.$message({message: '最多只能选择9张图片', type: 'error'});
                            return
                        }
                        let is_file = false
                        this.form.images.map((item)=>{
                            if(item.file_id === e[i].file_id){
                                is_file = true
                            }
                        })
                        if(is_file === false){
                            this.form.images.push(e[i])
                        }
                    }
                }
                if (this.file_name === 'video') { // 视频
                    this.form.file_id = e[0].file_id;
                    this.form.file = e[0]
                }
                if (this.file_name === 'audio') { // 音频
                    this.form.file_id = e[0].file_id;
                    this.form.file = e[0]
                }
                if (this.file_name === 'file') { // 文件
                    this.form.file_id = e[0].file_id;
                    this.form.file = e[0]
                }

                this.isupload = false;
            },

            /*删除文件*/
            deleteImg(index) {
                this.form.images.splice(index, 1);
            },
            delVideo(){
                this.form.video_id = 0;
                this.form.video = [];
            },
            delFile(){
                this.form.file_id = 0;
                this.form.file = [];
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
    .draggable-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .draggable-list .wrapper > span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/video/video/edit.vue